if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'), 
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', this.onSlideChanged.bind(this));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
          const activeMedia =
              this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
              this.elements.viewer.querySelector('[data-media-id]');
      
          if (!activeMedia) return;
      
          // Entferne die Klasse 'is-active' von allen Medien
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
              element.classList.remove('is-active');
          });
      
          // Füge die Klasse 'is-active' zum ausgewählten Medium hinzu
          activeMedia.classList.add('is-active');
      
          // **Nur Swiper-Slides auswählen**
          const allSlides = Array.from(this.elements.viewer.querySelectorAll('.swiper-slide'));
          const slideIndex = allSlides.indexOf(activeMedia);
      
          // **Nur wenn Swiper existiert und die Slide gefunden wurde**
          if (sliderImages && slideIndex !== -1) {
              sliderImages.slideTo(slideIndex, 300);
          }
      
          // Falls nötig, scroll den aktiven Media-Container
          if (!this.mql.matches || this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: "smooth" });
          }
      
          // **Setze das aktive Thumbnail**
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail) {
              this.setActiveThumbnail(activeThumbnail);
              this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
          }
      
          // **Swiper sofort updaten**
          if (sliderImages) sliderImages.update();
          if (sliderThumbs) sliderThumbs.update();
      }
 
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        // Entferne aria-current von allen Thumbnails
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        
        // Setze aria-current auf das aktive Thumbnail
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        // Verwende Swiper oder native Scrolling, um zum aktiven Thumbnail zu scrollen
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
